import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function UbicacionPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Map Section */}
      <section className="mt-16 sm:mt-20 lg:mt-24 h-[40vh] sm:h-[50vh] md:h-[60vh]">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.5!2d-79.5195!3d9.0082!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8faca8f5e8f5e8f5%3A0x5e8f5e8f5e8f5e8f!2sMegamall%20Panam%C3%A1!5e0!3m2!1ses!2spa!4v1700000000000!5m2!1ses!2spa"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Ubicación Artaca Tactic Panama en Megamall"
        ></iframe>
      </section>

      {/* Location Info Section */}
      <section className="bg-black py-10 sm:py-16 lg:py-20">
        <div className="w-full px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-10 md:gap-12">
            {/* Address */}
            <div>
              <h3 className="text-[#7cb342] text-xs font-semibold tracking-widest mb-3 sm:mb-4">
                UBICACIÓN
              </h3>
              <p className="text-white text-base sm:text-lg leading-relaxed mb-4 sm:mb-6">
                Megamall Panamá<br />
                Pasillo Entrada Azul<br />
                Kiosco #114<br />
                Frente a Jamar
              </p>
              <a
                href="https://maps.app.goo.gl/3wPnJKKebmyzNCpQ6"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 border-2 border-[#7cb342] hover:bg-[#7cb342] text-[#7cb342] hover:text-white px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg transition-all font-semibold text-sm sm:text-base whitespace-nowrap cursor-pointer"
              >
                <i className="ri-map-pin-line text-lg sm:text-xl w-5 h-5 flex items-center justify-center"></i>
                <span>ABRIR EN MAPS</span>
              </a>
            </div>

            {/* Hours */}
            <div>
              <h3 className="text-[#7cb342] text-xs font-semibold tracking-widest mb-3 sm:mb-4">
                HORARIOS
              </h3>
              <ul className="space-y-3 text-white text-sm sm:text-base">
                <li className="flex flex-col sm:flex-row sm:justify-between gap-0.5 sm:gap-2">
                  <span>Lunes - Viernes</span>
                  <span className="text-[#7cb342] font-semibold">10:00 AM - 9:00 PM</span>
                </li>
                <li className="flex flex-col sm:flex-row sm:justify-between gap-0.5 sm:gap-2">
                  <span>Sábado</span>
                  <span className="text-[#7cb342] font-semibold">10:00 AM - 9:00 PM</span>
                </li>
                <li className="flex flex-col sm:flex-row sm:justify-between gap-0.5 sm:gap-2">
                  <span>Domingo</span>
                  <span className="text-[#7cb342] font-semibold">10:00 AM - 9:00 PM</span>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="text-[#7cb342] text-xs font-semibold tracking-widest mb-3 sm:mb-4">
                CONTACTO DIRECTO
              </h3>
              <div className="flex flex-col items-start space-y-3 sm:space-y-4">
                <a
                  href="https://wa.me/50765358000"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 sm:w-16 sm:h-16 bg-[#7cb342] hover:bg-[#689f38] rounded-full flex items-center justify-center transition-colors cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-white text-2xl sm:text-3xl"></i>
                </a>
                <p className="text-white text-xl sm:text-2xl font-semibold">6535-8000</p>
                <a
                  href="https://instagram.com/artaca4"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-2 border-2 border-[#7cb342] hover:bg-[#7cb342] text-[#7cb342] hover:text-white px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg transition-all font-semibold text-sm sm:text-base whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-instagram-line text-lg sm:text-xl w-5 h-5 flex items-center justify-center"></i>
                  <span>@artaca4</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Directions Section */}
      <section className="bg-[#f8f8f6] py-10 sm:py-16 lg:py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12">
          <h2 className="text-black text-2xl sm:text-3xl lg:text-5xl font-bold mb-6 sm:mb-8 text-center">
            Cómo llegar
          </h2>
          <div className="bg-white rounded-xl sm:rounded-2xl p-5 sm:p-8 lg:p-12 shadow-lg">
            <div className="space-y-5 sm:space-y-6">
              <div className="flex items-start space-x-3 sm:space-x-4">
                <div className="w-9 h-9 sm:w-10 sm:h-10 bg-[#7cb342] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-car-line text-white text-lg sm:text-xl"></i>
                </div>
                <div>
                  <h3 className="text-black text-base sm:text-lg lg:text-xl font-semibold mb-1 sm:mb-2">
                    En automóvil
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                    Megamall está ubicado en la Vía Ricardo J. Alfaro (Tumba Muerto), con amplio
                    estacionamiento disponible. Busca la entrada azul y dirígete al kiosco #114.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-3 sm:space-x-4">
                <div className="w-9 h-9 sm:w-10 sm:h-10 bg-[#7cb342] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-bus-line text-white text-lg sm:text-xl"></i>
                </div>
                <div>
                  <h3 className="text-black text-base sm:text-lg lg:text-xl font-semibold mb-1 sm:mb-2">
                    En transporte público
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                    Múltiples rutas de buses pasan por Megamall. Pregunta por las rutas que van hacia
                    Tumba Muerto o Ricardo J. Alfaro.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-3 sm:space-x-4">
                <div className="w-9 h-9 sm:w-10 sm:h-10 bg-[#7cb342] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-white text-lg sm:text-xl"></i>
                </div>
                <div>
                  <h3 className="text-black text-base sm:text-lg lg:text-xl font-semibold mb-1 sm:mb-2">
                    Dentro del centro comercial
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                    Ingresa por la entrada azul y busca el kiosco #114. Estamos ubicados frente a la
                    tienda Jamar, en una ubicación de fácil acceso.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-[#1a3a2e] py-12 sm:py-16 lg:py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center">
          <h2 className="text-white text-2xl sm:text-3xl lg:text-5xl font-bold mb-4 sm:mb-6">
            ¿Tienes alguna pregunta?
          </h2>
          <p className="text-white/80 text-sm sm:text-base lg:text-lg mb-6 sm:mb-8 max-w-2xl mx-auto">
            Contáctanos por WhatsApp antes de visitarnos para confirmar disponibilidad de productos
          </p>
          <a
            href="https://wa.me/50765358000"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 bg-[#7cb342] hover:bg-[#689f38] text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-full transition-all font-semibold text-base sm:text-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-xl sm:text-2xl w-6 h-6 flex items-center justify-center"></i>
            <span>CHATEAR EN WHATSAPP</span>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
